import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.6 7.74304C12.5271 7.66699 12.4355 7.60573 12.3318 7.56368C12.228 7.52163 12.1147 7.49982 12 7.49982C11.8853 7.49982 11.772 7.52163 11.6682 7.56368C11.5645 7.60573 11.4729 7.66699 11.4 7.74304L4.65 15.4696C4.56643 15.5653 4.51554 15.679 4.50303 15.7981C4.49052 15.9172 4.51689 16.0369 4.57918 16.1439C4.64147 16.2508 4.73722 16.3408 4.8557 16.4037C4.97418 16.4665 5.11072 16.4998 5.25 16.4998H18.75C18.8893 16.4998 19.0258 16.4665 19.1443 16.4037C19.2628 16.3408 19.3585 16.2508 19.4208 16.1439C19.4831 16.0369 19.5095 15.9172 19.497 15.7981C19.4845 15.679 19.4336 15.5653 19.35 15.4696L12.6 7.74304Z",
		fill: "#636C7B"
	})
});
export default SvgTriangleUp;
